import React, { useState, useEffect, useCallback } from "react";
import {
  Archive,
  Home,
  Users,
  HelpCircle,
  CloudSunIcon,
  Film,
  HardHat,
  Bot,
  Download,
  Image as ImageIcon,
  KeyRound,
  Video,
  Move,
  Images,
  Settings,
  Play,
  Bell,
  FileText,
  Globe,
  ClipboardList,
  Sparkles,
  CalendarDays,
  Crop,
  Mail,
  Search as SearchIcon,
  ArrowLeftRight,
  PackageOpen,
  Boxes,
  Trophy,
  Rotate3d
} from "lucide-react";
import "../../styles/CameraDashboard.css";
import "../mobileStyles/MobileStyles.css";
import logo from "../../../media/resizedLogo.png";
import { collection, getDocs, query, where, limit } from "firebase/firestore";
import { db } from "../../../firebase-config";
import FAQTab from "../faq/FAQComponent.js";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import WorkInProgress from "../workInProgress/WorkInProgress.js";
import Comunidad from "../comunidad/Comunidad";
import WeatherComponent from "../weather/WeatherComponent.js";
import InstagramStoryTemplates from '../../../templateGenerator/components/TemplateGenerator';
import SocialStudio from '../../../socialStudio/SocialStudio';
import RedesSociales from '../../../redes/RedesSociales';
import TuCompetencia from '../../../competencia/TuCompetencia';
import ReportePDF from '../../../reportePdf/ReportePDF';
import PaginaWeb from '../../../paginaWeb/PaginaWebTab';
import Recorrido360 from '../../../recorrido360/Recorrido360';
import DatosObra from '../../../datosObra/DatosObra';
import Newsletter from '../../../newsletter/Newsletter';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MobileHeader from '../mobileHeader/MobileHeader';
import MobileSidebar from '../mobileSidebar/MobileSidebar';
import MobileContentWrapper from '../mobileContentWrapper/MobileContentWrapper';
import MobileCard from '../mobileCard/MobileCard';
import MobileButton from '../mobileButton/MobileButton';
import TopNavbar from '../topNavbar/TopNavbar';
import SubscriptionExpirationHandler from '../subscriptionExpirationHandler/SubscriptionExpirationHandler';
import NotificationBell from '../../../notifications/components/NotificationBell.tsx';
import NotificationPreferences from '../../../notifications/components/NotificationPreferences.tsx';
import useBreakpoint from '../../../hooks/useBreakpoint';
import SkeletonDashboard from "../skeletonDashboard/SkeletonDashboard";
import SeguridadHigiene from "../Seguridad/SeguridadHigiene";
import IADashboard from "../IADashboard/IADashboard";
import CalendarioObra from "../IADashboard/CalendarioObra";
import Maquinaria from "../IADashboard/inteligencia/Maquinaria";
import EntradasSalidas from "../IADashboard/inteligencia/EntradasSalidas";
import Materiales from "../IADashboard/inteligencia/Materiales";
import Acopio from "../IADashboard/inteligencia/Acopio";
import ComboIAGate from "../comboIA/ComboIAGate";
import { ITEMS_PRO, ITEMS_PRO_PLUS } from "../comboIA/comboIA";
import SeguridadGate from "../comboIA/SeguridadGate";
import ZonasDeteccion from "../IADashboard/ZonasDeteccion";
import ArchivoFotografico from "../archivoFotografico/ArchivoFotografico";
import InicioMediaCard from "../firstLastImageCompare/InicioMediaCard";
import Licencia from "../licencia/Licencia";
import Alertas from "../alertas/Alertas";
import useLisualWidget from "../../../utils/useLisualWidget";
import VideoEditor from "../../../videoEditor/components/VideoEditor";
import RopLiveViewTab from "../../../rop/components/RopLiveViewTab";
import RopMoverTab from "../../../rop/components/RopMoverTab";
import RopImagenesTab from "../../../rop/components/RopImagenesTab";
import RopConfiguracionTab from "../../../rop/components/RopConfiguracionTab";
import { getCamaraBillingType, getIngestAlerts } from "../../../camaraManager/api/camaraManager.api";
import { getAuthClaims } from "../../../utils/authToken";
import { setAuthRedirect } from "../../../utils/authRedirect";
import { useIsAdmin } from "../../../rop/hooks/useIsAdmin";

// Nombres de pestaña viejos -> nuevos (el gate de combos y los links guardados pueden seguir usando el viejo).
// "IA" pasó a ser "Seguridad e Higiene" (24/10), dentro de IA Pro.
const TAB_ALIAS = { Maquinaria: "Buscador de obra", IA: "Seguridad e Higiene" };
// "Primera Imagen" y "Descargar imágenes" salieron del menú Obra (03/11): son secciones de Archivo Fotográfico.
// Los nombres viejos (links, initialTab, botones) siguen funcionando: abren esa sección.
export const SECCION_DE_PESTANA = { "Primera Imagen": "primera", "Descargar imágenes": "descargar", "Descargar Imágenes": "descargar" };
const resolverPestana = (tabName) => (SECCION_DE_PESTANA[tabName]
  ? { tab: "Archivo Fotografico", seccion: SECCION_DE_PESTANA[tabName] }
  : { tab: TAB_ALIAS[tabName] || tabName, seccion: "fotos" });

/** Ítems del menú Inteligencia. conIa = la cámara tiene pirAnalytics y datos de IA. Exportado para /__preview-menu.
 *  Las pantallas de IA Pro (y el adicional Seguridad e Higiene) se ven en todas las cámaras: sin el plan muestran la activación. */
export const itemsInteligencia = (conIa) => [...(conIa ? ['Dashboard IA'] : []), 'Buscador de obra', 'Entradas y salidas', 'Materiales', 'Acopio', 'Seguridad e Higiene', ...(conIa ? ['Zonas de detección'] : []), 'Alertas', 'Reporte PDF'];

/** Ítems del menú Obra (Primera Imagen y Descargar imágenes están dentro de Archivo Fotografico). Exportado para /__preview-archivo. */
export const itemsObra = (conCalendario, conLicencia) => ['Datos de la obra', 'Archivo Fotografico', ...(conCalendario ? ['Calendario'] : []), 'Clima', ...(conLicencia ? ['Licencia'] : [])];

const CameraDashboard = () => {
  const { identifier } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = useIsAdmin();

  // Initialize Auth Redirect utility
  useEffect(() => {
    setAuthRedirect(navigate);
  }, [navigate]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showNotifPrefs, setShowNotifPrefs] = useState(false);
  const { isDesktop } = useBreakpoint();
  // Default tab: Camera Home if user has camera, else Inicio
  const [activeTab, setActiveTab] = useState((location.state?.initialTab && resolverPestana(location.state.initialTab).tab) || (new URLSearchParams(location.search).get("nl_wa") ? "Newsletter" : new URLSearchParams(location.search).get("ae") ? "Alertas" : "Inicio"));
  const [seccionArchivo, setSeccionArchivo] = useState(() => (location.state?.initialTab ? resolverPestana(location.state.initialTab).seccion : "fotos"));
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [userdata, setUserData] = useState({});
  // ¿La cámara tiene datos de IA de los últimos 2 meses? Si no, no se muestran pestañas de IA vacías.
  const [hasIaData, setHasIaData] = useState(false);
  useEffect(() => {
    if (!userdata.pirAnalytics || !userdata.customerId || !userdata.identifier) { setHasIaData(false); return; }
    let alive = true;
    const camId = userdata.customerId + (userdata.identifier.startsWith('P_') ? userdata.identifier.slice(2) : userdata.identifier);
    const now = new Date();
    const months = [0, 1].map((back) => { const d = new Date(now.getFullYear(), now.getMonth() - back, 1); return [String(d.getFullYear()), String(d.getMonth() + 1).padStart(2, '0')]; });
    Promise.all(months.map(([y, m]) => getDocs(query(collection(db, 'pirIaAnalyzes', camId, y, m, 'day'), limit(1))).then((q) => !q.empty).catch(() => false)))
      .then((r) => alive && setHasIaData(r.some(Boolean)));
    return () => { alive = false; };
  }, [userdata.pirAnalytics, userdata.customerId, userdata.identifier]);
  const [isLoading, setIsLoading] = useState(true);
  const [sidebarLogo, setSidebarLogo] = useState(logo); // Default to imported logo
  const [globalError, setGlobalError] = useState(null);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [hasCheckedSubscription, setHasCheckedSubscription] = useState(false);
  const [customerData, setCustomerData] = useState(null); // New state for customer data
  const [billingType, setBillingType] = useState(null);

  const { token: authToken, role: authRole, customerId: effectiveCustomerId } = getAuthClaims();
  // The camera's actual owner may differ from the logged-in account's own customerId
  // (e.g. an admin browsing another customer's camera), so prefer it for the back link.
  const projectCustomerId = userdata?.customerId ? String(userdata.customerId) : null;
  const backDestinationPath = (() => {
    if (!authToken) return null;
    if (authRole === "guest" && effectiveCustomerId) return `/guestDashboard/${effectiveCustomerId}`;
    if (authRole === "guest") return null;
    if (projectCustomerId) return `/customerDashboard/${projectCustomerId}`;
    if (effectiveCustomerId) return `/customerDashboard/${effectiveCustomerId}`;
    if (authRole === "admin") {
      return "/adminDashboard";
    }
    return "/";
  })();
  const canShowBackToCustomerDashboard = Boolean(authToken) && authRole !== "guest" && Boolean(backDestinationPath);

  // Widget de ayuda: reconoce al usuario logueado y arranca en esta cámara.
  useLisualWidget({ feedId: userdata?.feedID || "", feedName: userdata?.Name || "", customerId: userdata?.customerId || "", customerName: customerData?.name || "", customerPhone: customerData?.mainUserPhone || "", ready: !isLoading && !!customerData });

  // "Maquinaria" pasó a llamarse "Buscador de obra" (17/10): el nombre viejo sigue funcionando como alias.
  // "Primera Imagen" / "Descargar imágenes" abren su sección dentro de Archivo Fotográfico.
  const handleTabClick = useCallback((tabName) => {
    const { tab, seccion } = resolverPestana(tabName);
    setActiveTab(tab);
    setSeccionArchivo(seccion);
  }, []);

  useEffect(() => {
    fetchPost();
  }, [identifier]); // Add identifier to dependency array

  // El back viejo (de donde viene `userdata`) no conoce billingType, vive solo
  // en el webback nuevo, así que se pide acá aparte por identifier.
  useEffect(() => {
    if (!identifier) return;

    let cancelled = false;
    getCamaraBillingType(identifier)
      .then((data) => {
        if (cancelled) return;
        setBillingType(data.billingType || "paquete_dias");
      })
      .catch((error) => {
        console.error("Error al obtener el tipo de licencia de la cámara:", error);
      });

    return () => {
      cancelled = true;
    };
  }, [identifier]);

  // Igual que billingType: ingestAlertsEnabled solo vive en el webback nuevo,
  // así que se pide acá aparte y se mergea en userdata. A diferencia de
  // billingType, este endpoint busca por feedID (== FtpUser.username en
  // MySQL), no por identifier — mismo criterio que camara-apagada/Licencia.
  useEffect(() => {
    if (!userdata?.feedID) return;

    let cancelled = false;
    getIngestAlerts(userdata.feedID)
      .then((data) => {
        if (cancelled) return;
        setUserData((prev) => ({ ...prev, ingestAlertsEnabled: data.ingestAlertsEnabled ?? false }));
      })
      .catch((error) => {
        console.error("Error al obtener el estado de alertas de ingesta de la cámara:", error);
      });

    return () => {
      cancelled = true;
    };
  }, [userdata?.feedID]);

  const fetchPost = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "usuarios"));

      const newData = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      const userData = newData.find(
          (element) => element.identifier === identifier
      );
      if (userData) {
        setUserData(userData);

        // Buscar datos del cliente si existe customerId
        if (userData.customerId) {
          const q = query(collection(db, "customers"), where("customerId", "==", userData.customerId));
          const customerSnapshot = await getDocs(q);
          if (!customerSnapshot.empty) {
            const customerDoc = customerSnapshot.docs[0];
            setCustomerData({ id: customerDoc.id, ...customerDoc.data() });
          }
        }

        if (userData.logo) {
          setSidebarLogo(userData.logo);
        } else {
          setSidebarLogo(logo);
        }
      } else {
        setGlobalError('Usuario no encontrado.');
        toast.error('Usuario no encontrado.');
        navigate("/", { replace: true });
      }
    } catch (error) {
      setGlobalError('Error al cargar los datos del usuario.');
      toast.error('Error al cargar los datos del usuario.');
      navigate("/", { replace: true });
    } finally {
      setIsLoading(false);
    }
  };

  // Check subscription status and show modal if expired
  useEffect(() => {
    // billingType llega aparte del webback; hasta tenerlo no se sabe si aplica el cartel.
    if (!isLoading && billingType && userdata && Object.keys(userdata).length > 0 && !hasCheckedSubscription) {
      // Monthly licenses renew on a fixed day, so there is no days-left expiration to warn about
      if (billingType !== 'mensual' && userdata.feedDays && typeof userdata.feedDays.daysLeft === 'number') {
        if (userdata.feedDays.daysLeft <= 0) {
          setShowSubscriptionModal(true);
        }
      }
      setHasCheckedSubscription(true);
    }
  }, [isLoading, userdata, billingType, hasCheckedSubscription]);

  // Show a friendly error card if user data fails to load
  if (globalError) {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
          <div className="bg-white p-8 rounded-2xl shadow-xl border border-red-200 flex flex-col items-center">
            <span className="text-4xl mb-4">😢</span>
            <h2 className="text-2xl font-bold text-red-600 mb-2">¡Vaya!</h2>
            <p className="text-gray-700 mb-4">{globalError}</p>
            <button onClick={() => navigate("/")} className="px-6 py-2 bg-blue-600 text-white rounded-lg font-semibold shadow hover:bg-blue-700 transition">Volver al inicio</button>
          </div>
          <ToastContainer position="top-center" autoClose={4000} />
        </div>
    );
  }

  const renderContent = () => {
    switch (activeTab) {
      case "Inicio":
        return (
            <div className="space-y-3 mt-1 md:-mt-2">
              {/* Antes y Ahora / Rayos X / Timelapse (same physical space) */}
              {userdata?.feedID && (
                  <InicioMediaCard userdata={userdata} onGoToFirstImage={() => handleTabClick("Primera Imagen")} onOpenEditor={() => setActiveTab("Editor de Video")} empresa={{ customerId: userdata?.customerId || "", customerName: customerData?.name || "", customerPhone: customerData?.mainUserPhone || "", logo: customerData?.logo || "" }} />
              )}
              <div className="grid grid-cols-1  gap-2">
                  <MobileButton
                      variant="primary"
                      size="lg"
                      fullWidth
                      onClick={() => window.open("https://wa.me/5491128263237", "_blank")}
                      icon={<Bot className="w-5 h-5" />}
                      className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700"
                  >

                    <span className="text-xs text-left leading-tight">
                     El player muestra un timelapse máximo de 90 días, presiona para obtener un timelapse a medida con el asistente.
                   </span>
                  </MobileButton>
                </div>

              {/* Quick Actions */}
              <div className="grid grid-cols-1  gap-2">
                <MobileButton
                    variant="primary"
                    size="lg"
                    fullWidth
                    onClick={() => handleTabClick("Archivo Fotografico")}
                    icon={<Archive className="w-5 h-5" />}
                    className="bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700"
                >
                  Explorar Archivo
                </MobileButton>
              </div>

              {/* Project Status Section */}
              {!userdata?.feedID && (
                <MobileCard className="bg-amber-50 border-amber-200">
                  <p className="text-amber-700 text-sm text-center">Este proyecto no tiene un Feed ID configurado para el análisis.</p>
                </MobileCard>
              )}

            </div>
        );
      case "Comunidad":
        return (
            <div className="space-y-6">
              <Comunidad />
            </div>
        );
      case "Archivo Fotografico":
        return (
            <ArchivoFotografico
                user={userdata}
                seccion={seccionArchivo}
                onSeccion={setSeccionArchivo}
                selectedDate={selectedDate}
                onDateSelect={setSelectedDate}
            />
        );
      case "Timelapse":
        return (
            <div className="space-y-6">
              <WorkInProgress />
            </div>
        );
      case "Dashboard IA":
        return (
            <div className="space-y-6">
              <IADashboard
                  customerId={userdata.customerId}
                  camIdentifier={identifier}
                  camName={userdata.Name}
                  coords={userdata.coordinates}
                  feedId={userdata.feedID}
                  onEditZonas={() => handleTabClick("Zonas de detección")}
              />
            </div>
        );
      case "Zonas de detección":
        return (
            <ZonasDeteccion
                customerId={userdata.customerId}
                camIdentifier={identifier}
                camName={userdata.Name}
                feedId={userdata.feedID}
                onVerDashboard={() => handleTabClick("Dashboard IA")}
            />
        );
      case "Seguridad e Higiene":
      case "IA":
        return (
            <div className="space-y-6">
              {/* Adicional de IA Pro (USD 10/mes): sin IA Pro o sin el adicional se ve la pantalla de activación */}
              <SeguridadGate feedID={userdata.feedID}>
                <SeguridadHigiene
                    customerId={userdata.customerId}
                    cam={identifier}
                    name={userdata.Name}
                    feedId={userdata.feedID}
                    onIrA={handleTabClick}
                />
              </SeguridadGate>
            </div>
        );
      case "Ayuda":
        return (
            <div className="space-y-6">
              <MobileCard>
                <FAQTab />
              </MobileCard>
            </div>
        );
      case "Calendario":
        return (
            <div className="space-y-6">
              <CalendarioObra
                  customerId={userdata.customerId}
                  cam={identifier}
                  name={userdata.Name}
                  coords={userdata.coordinates}
                  feedId={userdata.feedID}
              />
            </div>
        );
      case "Buscador de obra":
      case "Maquinaria":
      case "Entradas y salidas":
      case "Materiales":
      case "Acopio": {
        const Pagina = { "Buscador de obra": Maquinaria, Maquinaria, "Entradas y salidas": EntradasSalidas, Materiales, Acopio }[activeTab];
        return (
            <div className="space-y-6">
              {/* Combo "IA de obra": sin el combo se ve la pantalla de venta; en prueba, una banda con los días */}
              <ComboIAGate feedID={userdata.feedID} pagina={activeTab}>
                <Pagina customerId={userdata.customerId} cam={identifier} name={userdata.Name} feedId={userdata.feedID} />
              </ComboIAGate>
            </div>
        );
      }
      case "Clima":
        return (
            <div className="space-y-6">
              <MobileCard>
                <WeatherComponent user={userdata} empresa={{ customerName: customerData?.name || "", logo: customerData?.logo || "" }} />
              </MobileCard>
            </div>
        );
      case "Datos de la obra":
        return <DatosObra user={userdata} customerInfo={customerData} identifier={identifier} onIrA={handleTabClick} />;
      case "Página web":
        return <PaginaWeb user={userdata} customerInfo={customerData} identifier={identifier} onIrA={handleTabClick} />;
      case "Recorrido 360°":
        return <Recorrido360 user={userdata} customerInfo={customerData} />;
      case "Newsletter":
        return isAdmin ? <Newsletter user={userdata} customerInfo={customerData} /> : null;
      case "Reporte PDF":
        return <ReportePDF user={userdata} customerInfo={customerData} identifier={identifier} />;
      case "Redes Sociales":
        // Conectar redes y programar. Regla: "si no está aprobado, no lo publiques" — el backend sólo le muestra
        // al cliente las redes que ya aprobaron la app (REDES_APROBADAS); si no hay ninguna, el cliente ve sólo
        // las plantillas, como siempre. Los admins ven todo, con Instagram/Facebook marcadas "en aprobación".
        return (
            <div className="space-y-8">
              <RedesSociales
                  user={userdata}
                  customerInfo={customerData}
                  isAdmin={isAdmin}
                  vidriera={(onProgramar) => (
                      <div className="space-y-8">
                        <SocialStudio user={userdata} customerInfo={customerData} identifier={identifier} onProgramar={onProgramar} />
                        <details className="bg-white border border-gray-200 rounded-2xl p-4">
                          <summary className="cursor-pointer text-sm font-semibold text-gray-700">Plantillas de imagen anteriores</summary>
                          <div className="mt-4">
                            <InstagramStoryTemplates user={userdata} customerInfo={customerData} />
                          </div>
                        </details>
                      </div>
                  )}
              />
            </div>
        );
      case "Tu competencia":
        return <TuCompetencia user={userdata} isAdmin={isAdmin} />;
      case "Editor de Video":
        return <VideoEditor user={userdata} />;
      case "Licencia":
        return (
            <div className="space-y-6">
              <Licencia
                  feedID={userdata?.feedID}
                  daysLeft={userdata?.feedDays?.daysLeft ?? 0}
                  totalDays={userdata?.feedDays?.totalDays ?? 0}
                  camaraApagada={userdata?.camaraApagada ?? false}
                  onCamaraApagadaChange={(value) => setUserData((prev) => ({ ...prev, camaraApagada: value }))}
              />
            </div>
        );
      case "Alertas":
        return (
            <div className="space-y-6">
              <Alertas
                  feedID={userdata?.feedID}
                  ingestAlertsEnabled={userdata?.ingestAlertsEnabled ?? false}
                  onIngestAlertsChange={(value) => setUserData((prev) => ({ ...prev, ingestAlertsEnabled: value }))}
              />
            </div>
        );
      case "Ver en vivo":
        return <RopLiveViewTab uid={userdata?.camaraUID} />;
      case "Mover":
        return isAdmin ? <RopMoverTab uid={userdata?.camaraUID} /> : null;
      case "Imágenes":
        return <RopImagenesTab uid={userdata?.camaraUID} />;
      case "Configuración":
        return <RopConfiguracionTab uid={userdata?.camaraUID} />;
      default:
        return (
            <div className="space-y-6">
              <MobileCard>
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">{activeTab}</h2>
                <div className="text-center">
                  <img
                      src="/api/placeholder/800/400"
                      alt="Seccion en progreso!"
                      className="w-full h-48 object-cover rounded-lg mx-auto"
                  />
                  <p className="text-gray-600 mt-4">Esta sección está en desarrollo</p>
                </div>
              </MobileCard>
            </div>
        );
    }
  };

  const handleLogout = () => {
    // Navigate to customer dashboard if available, otherwise to login
    if (effectiveCustomerId) {
      navigate(`/customerDashboard/${effectiveCustomerId}`);
    } else {
      navigate('/');
    }
  };

  const menuItems = [
    { name: "Inicio", icon: <Home size={24} /> },
  ].filter(Boolean);

  const groupedTabs = [
    { label: 'Obra', items: itemsObra(!!(userdata.pirAnalytics && hasIaData), !!(billingType && billingType !== 'mensual')) },
    { label: 'Inteligencia', items: itemsInteligencia(!!(userdata.pirAnalytics && hasIaData)) },
    { label: 'Marketing', items: ['Redes Sociales', 'Tu competencia', ...(isAdmin ? ['Newsletter'] : []), 'Editor de Video', 'Comunidad'] },
    // Pestañas sueltas (sin desplegable). Recorrido 360° = lo de la Insta360 (o contratarlo); Página web = las webs sin 360 (o pedirla).
    { label: 'Recorrido 360°', items: ['Recorrido 360°'], single: true },
    { label: 'Página web', items: ['Página web'], single: true },
    { label: 'Soporte', items: ['Ayuda'] },
    // Fase 3 (final) de ROP agrega 'Configuración' junto a 'Mover' (fase 1) e
    // 'Imágenes' (fase 2). 'Mover' es admin-only: un usuario no-admin no debe
    // ver esa opción en el menú.
    ...(userdata.ropActive
      ? [
          {
            label: 'Camara',
            items: [
              'Ver en vivo',
              ...(isAdmin ? ['Mover'] : []),
              'Imágenes',
              'Configuración',
            ],
          },
        ]
      : []),
  ];

  // Campanita: las Novedades de Lisual van ahí (ya no como franja en el Inicio) + preferencias de WhatsApp
  const campanita = (
      <NotificationBell customerId={userdata?.customerId} notices={[]} onOpenPreferences={userdata?.customerId ? () => setShowNotifPrefs(true) : undefined} />
  );

  const badgeMap = { ...Object.fromEntries(ITEMS_PRO.map((n) => [n, 'PRO'])), ...Object.fromEntries(ITEMS_PRO_PLUS.map((n) => [n, 'PRO+'])) };

  return (
      <div className="flex h-dvh overflow-hidden bg-gray-100">

        {/* Mobile Header - Only visible on mobile */}
        <MobileHeader
            sidebarLogo={sidebarLogo}
            onMenuClick={() => setIsSidebarOpen(true)}
            userdata={userdata}
            activeTab={activeTab}
            onNotificationClick={() => {/* Handle notifications */}}
            onProfileClick={() => {/* Handle profile */}}
            rightSlot={!isDesktop ? campanita : null}
        />

        {/* Mobile Sidebar - Only visible on mobile */}
        <MobileSidebar
            isOpen={isSidebarOpen}
            onClose={() => setIsSidebarOpen(false)}
            activeTab={activeTab}
            setActiveTab={handleTabClick}
            userdata={userdata}
            sidebarLogo={sidebarLogo}
            navigate={navigate}
            menuItems={menuItems}
            groupedTabs={groupedTabs}
            badgeMap={badgeMap}
            canShowBackButton={canShowBackToCustomerDashboard}
            customerDashboardPath={backDestinationPath}
            iconMap={{
              'Archivo Fotografico': <Archive size={16} />,
              'Primera Imagen': <ImageIcon size={16} />,
              'Redes Sociales': <Film size={16} />,
              'Tu competencia': <Trophy size={16} />,
              'Reporte PDF': <FileText size={16} />,
              'Página web': <Globe size={16} />,
              'Recorrido 360°': <Rotate3d size={16} />,
              'Datos de la obra': <ClipboardList size={16} />,
              'Newsletter': <Mail size={16} />,
              'Ayuda': <HelpCircle size={16} />,
              'Comunidad': <Users size={16} />,
              'Clima': <CloudSunIcon size={16} />,
              'Calendario': <CalendarDays size={16} />,
              'Dashboard IA': <Sparkles size={16} />,
              'Zonas de detección': <Crop size={16} />,
              'Buscador de obra': <SearchIcon size={16} />,
              'Maquinaria': <SearchIcon size={16} />,
              'Entradas y salidas': <ArrowLeftRight size={16} />,
              'Materiales': <PackageOpen size={16} />,
              'Acopio': <Boxes size={16} />,
              'Seguridad e Higiene': <HardHat size={16} />,
              'Descargar imágenes': <Download size={16} />,
              'Licencia': <KeyRound size={16} />,
              'Alertas': <Bell size={16} />,
              'Editor de Video': <Video size={16} />,
              'Ver en vivo': <Play size={16} />,
              'Mover': <Move size={16} />,
              'Imágenes': <Images size={16} />,
              'Configuración': <Settings size={16} />
            }}
        />

        {/* Top Navbar for desktop */}
        <TopNavbar
            sidebarLogo={sidebarLogo}
            menuItems={menuItems}
            groupedTabs={groupedTabs}
            badgeMap={badgeMap}
            activeTab={activeTab}
            setActiveTab={handleTabClick}
            canShowBackButton={canShowBackToCustomerDashboard}
            customerDashboardPath={backDestinationPath}
            rightSlot={isDesktop ? campanita : null}
            iconMap={{
              'Archivo Fotografico': <Archive size={16} />,
              'Primera Imagen': <ImageIcon size={16} />,
              'Redes Sociales': <Film size={16} />,
              'Tu competencia': <Trophy size={16} />,
              'Reporte PDF': <FileText size={16} />,
              'Página web': <Globe size={16} />,
              'Recorrido 360°': <Rotate3d size={16} />,
              'Datos de la obra': <ClipboardList size={16} />,
              'Newsletter': <Mail size={16} />,
              'Ayuda': <HelpCircle size={16} />,
              'Comunidad': <Users size={16} />,
              'Clima': <CloudSunIcon size={16} />,
              'Calendario': <CalendarDays size={16} />,
              'Dashboard IA': <Sparkles size={16} />,
              'Zonas de detección': <Crop size={16} />,
              'Buscador de obra': <SearchIcon size={16} />,
              'Maquinaria': <SearchIcon size={16} />,
              'Entradas y salidas': <ArrowLeftRight size={16} />,
              'Materiales': <PackageOpen size={16} />,
              'Acopio': <Boxes size={16} />,
              'Seguridad e Higiene': <HardHat size={16} />,
              'Descargar imágenes': <Download size={16} />,
              'Licencia': <KeyRound size={16} />,
              'Alertas': <Bell size={16} />,
              'Editor de Video': <Video size={16} />,
              'Ver en vivo': <Play size={16} />,
              'Mover': <Move size={16} />,
              'Imágenes': <Images size={16} />,
              'Configuración': <Settings size={16} />
            }}
        />

        {/* Main content wrapper */}
        <div className={`flex-1 flex flex-col lg:pt-[64px] min-h-0`}>
          {/* Main content area */}
          <main className="flex-1 w-full overflow-y-auto bg-gray-100 mt-14 lg:mt-0 lg:p-6 min-h-0">
            <div className={`${activeTab === "Recorrido 360°" || activeTab === "Página web" ? "max-w-7xl" : "max-w-5xl"} mx-auto w-full h-full`}>
              <MobileContentWrapper compactTop={activeTab === "Inicio"}>
                {isLoading ? (
                    <div className="w-full">
                      <SkeletonDashboard />
                    </div>
                ) : (
                    <div key={activeTab} className="w-full">
                      {renderContent()}
                    </div>
                )}
              </MobileContentWrapper>
            </div>
          </main>
        </div>
        <NotificationPreferences customerId={userdata?.customerId} isOpen={showNotifPrefs} onClose={() => setShowNotifPrefs(false)} />
        <ToastContainer position="top-center" autoClose={4000} />

        {/* Subscription Expiration Handler */}
        <SubscriptionExpirationHandler
            daysLeft={userdata?.feedDays?.daysLeft ?? 0}
            isOpen={showSubscriptionModal}
            onClose={() => setShowSubscriptionModal(false)}
            onLogout={handleLogout}
        />
      </div>
  );
};

export default CameraDashboard;
